import { render, staticRenderFns } from "./Transfer_from_debtor.vue?vue&type=template&id=590fdd3e&scoped=true&"
import script from "./Transfer_from_debtor.vue?vue&type=script&lang=js&"
export * from "./Transfer_from_debtor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590fdd3e",
  null
  
)

export default component.exports